import { billing } from '@saucelabs/sl-util-axios';

export const fetchRecurlyToken = (form) => new Promise((resolve, reject) => {
  recurly.token(form, (err, token) => {
    if (err) {
      reject(err);
    } else {
      resolve(token);
    }
  });
});

export const getBillingInfo = () => billing.get('/billing');

export const updateBillingInfo = (params) => billing.post('/billing', params);

export const getAccount = () => billing.get('/account_or_null');

export const updateAccount = (params) => billing.post('/account', params);
